// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125RouteImport } from './routes/{-$locale}'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125BarrierefreiheitRouteImport } from './routes/{-$locale}/barrierefreiheit'
import { Route as Char123LocaleChar125DatenschutzRouteImport } from './routes/{-$locale}/datenschutz'
import { Route as Char123LocaleChar125ImpressumRouteImport } from './routes/{-$locale}/impressum'
import { Route as Char123LocaleChar125KarriereRouteImport } from './routes/{-$locale}/karriere'
import { Route as Char123LocaleChar125KontaktRouteImport } from './routes/{-$locale}/kontakt'
import { Route as Char123LocaleChar125LeistungenRouteImport } from './routes/{-$locale}/leistungen'
import { Route as Char123LocaleChar125PraxisRouteImport } from './routes/{-$locale}/praxis'
import { Route as Char123LocaleChar125QualifikationRouteImport } from './routes/{-$locale}/qualifikation'
import { Route as Char123LocaleChar125AdminIndexRouteImport } from './routes/{-$locale}/admin/index'
import { Route as Char123LocaleChar125AdminChatRouteImport } from './routes/{-$locale}/admin/chat'
import { Route as Char123LocaleChar125AdminVacationsRouteImport } from './routes/{-$locale}/admin/vacations'
import { Route as Char123LocaleChar125AdminVisitorChatsRouteImport } from './routes/{-$locale}/admin/visitor-chats'

const Char123LocaleChar125Route = Char123LocaleChar125RouteImport.update({
            id: '/{-$locale}',path: '/{-$locale}',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125IndexRoute = Char123LocaleChar125IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125BarrierefreiheitRoute = Char123LocaleChar125BarrierefreiheitRouteImport.update({
            id: '/barrierefreiheit',path: '/barrierefreiheit',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125DatenschutzRoute = Char123LocaleChar125DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125ImpressumRoute = Char123LocaleChar125ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125KarriereRoute = Char123LocaleChar125KarriereRouteImport.update({
            id: '/karriere',path: '/karriere',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125KontaktRoute = Char123LocaleChar125KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125LeistungenRoute = Char123LocaleChar125LeistungenRouteImport.update({
            id: '/leistungen',path: '/leistungen',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125PraxisRoute = Char123LocaleChar125PraxisRouteImport.update({
            id: '/praxis',path: '/praxis',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125QualifikationRoute = Char123LocaleChar125QualifikationRouteImport.update({
            id: '/qualifikation',path: '/qualifikation',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125AdminIndexRoute = Char123LocaleChar125AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125AdminChatRoute = Char123LocaleChar125AdminChatRouteImport.update({
            id: '/admin/chat',path: '/admin/chat',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125AdminVacationsRoute = Char123LocaleChar125AdminVacationsRouteImport.update({
            id: '/admin/vacations',path: '/admin/vacations',getParentRoute: () => Char123LocaleChar125Route
          })
const Char123LocaleChar125AdminVisitorChatsRoute = Char123LocaleChar125AdminVisitorChatsRouteImport.update({
            id: '/admin/visitor-chats',path: '/admin/visitor-chats',getParentRoute: () => Char123LocaleChar125Route
          })





const Char123LocaleChar125RouteChildren = {
  Char123LocaleChar125BarrierefreiheitRoute: Char123LocaleChar125BarrierefreiheitRoute,Char123LocaleChar125DatenschutzRoute: Char123LocaleChar125DatenschutzRoute,Char123LocaleChar125ImpressumRoute: Char123LocaleChar125ImpressumRoute,Char123LocaleChar125KarriereRoute: Char123LocaleChar125KarriereRoute,Char123LocaleChar125KontaktRoute: Char123LocaleChar125KontaktRoute,Char123LocaleChar125LeistungenRoute: Char123LocaleChar125LeistungenRoute,Char123LocaleChar125PraxisRoute: Char123LocaleChar125PraxisRoute,Char123LocaleChar125QualifikationRoute: Char123LocaleChar125QualifikationRoute,Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,Char123LocaleChar125AdminChatRoute: Char123LocaleChar125AdminChatRoute,Char123LocaleChar125AdminVacationsRoute: Char123LocaleChar125AdminVacationsRoute,Char123LocaleChar125AdminVisitorChatsRoute: Char123LocaleChar125AdminVisitorChatsRoute,Char123LocaleChar125AdminIndexRoute: Char123LocaleChar125AdminIndexRoute
}

const Char123LocaleChar125RouteWithChildren = Char123LocaleChar125Route._addFileChildren(Char123LocaleChar125RouteChildren)

const rootRouteChildren = {
  Char123LocaleChar125Route: Char123LocaleChar125RouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)